import "./styles/quasar.scss";
import iconSet from "quasar/icon-set/mdi-v4.js";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/mdi-v4/mdi-v4.css";

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {},
  iconSet: iconSet,
};
